import { useState } from "react";
import SectionCard from "./AccounSettingSectionCard";
import NotificationToggle from "./NotificationToggle";
import Button from "../common/Button";
import { Save } from "lucide-react";

const NotificationSettings = () => {
  const [prefs, setPrefs] = useState({
    jobAlerts: true,
    applicationUpdates: true,
    profileViews: false,
    marketingEmails: true,
    securityAlerts: true,
    weeklyDigest: false,
  });
  const [isSaving, setIsSaving] = useState(false);
  const [notification, setNotification] = useState({ message: "", type: "" });

  const handleToggle = (key) => {
    setPrefs((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSave = () => {
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      setNotification({
        message: "Notification preferences saved!",
        type: "success",
      });
      setTimeout(() => setNotification({ message: "", type: "" }), 3000);
    }, 1000);
  };

  return (
    <SectionCard title="Email Notifications">
      <div className="space-y-5 divide-y divide-secondary-100">
        <NotificationToggle
          label="Job Alerts"
          description="Get notified about new job opportunities matching your profile"
          isEnabled={prefs.jobAlerts}
          onToggle={() => handleToggle("jobAlerts")}
        />
        <NotificationToggle
          label="Application Updates"
          description="Receive updates about your job applications"
          isEnabled={prefs.applicationUpdates}
          onToggle={() => handleToggle("applicationUpdates")}
        />
        <NotificationToggle
          label="Profile Views"
          description="Know when recruiters view your profile"
          isEnabled={prefs.profileViews}
          onToggle={() => handleToggle("profileViews")}
        />
        <NotificationToggle
          label="Marketing Emails"
          description="Receive tips, news, and product updates"
          isEnabled={prefs.marketingEmails}
          onToggle={() => handleToggle("marketingEmails")}
        />
        <NotificationToggle
          label="Security Alerts"
          description="Important security and account notifications"
          isEnabled={prefs.securityAlerts}
          onToggle={() => handleToggle("securityAlerts")}
        />
        <NotificationToggle
          label="Weekly Digest"
          description="Weekly summary of your account activity"
          isEnabled={prefs.weeklyDigest}
          onToggle={() => handleToggle("weeklyDigest")}
        />
      </div>
      <div className="mt-8 pt-6 border-t border-secondary-100 flex justify-end">
        <Button
          onClick={handleSave}
          loading={isSaving}
          icon={<Save className="w-4 h-4 mr-2" />}
        >
          Save Preferences
        </Button>
      </div>
      {notification.message && (
        <p className="text-green-600 text-sm mt-4 text-right">
          {notification.message}
        </p>
      )}
    </SectionCard>
  );
};

export default NotificationSettings;